import { Component, ElementRef, Renderer2,OnDestroy } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
  query,
  stagger,
} from '@angular/animations';

@Component({
  selector: 'app-speed-dial',
  templateUrl: './speed-dial.component.html',
  styleUrls: ['./speed-dial.component.scss'],
  animations: [
    trigger('rotateFab', [
      state('open', style({ transform: 'rotate(45deg)' })),
      state('closed', style({ transform: 'rotate(0deg)' })),
      transition('closed => open', [animate('0.3s ease-in-out')]),
      transition('open => closed', [animate('0.3s ease-in-out')]),
    ]),
    trigger('optionAppear', [
      transition(':enter', [
        query(
          '.fab-option',
          [
            style({ opacity: 0, transform: 'translateY(20px)' }),
            stagger(100, [
              animate('0.3s ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
            ])
          ],
          { optional: true }
        ),
      ]),
      transition(':leave', [
        query(
          '.fab-option',
          [
            stagger(-100, [
              animate('0.2s ease-in', style({ opacity: 0, transform: 'translateY(20px)' }))
            ])
          ],
          { optional: true }
        ),
      ]),
    ]),
  ],

})
export class SpeedDialComponent implements OnDestroy {
  isDialOpen = false;
  phoneNumber = '+918800909063'; // Replace with dynamic or input-driven number
  private documentClickListener: (() => void) | null = null;
  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  toggleDial() {
    this.isDialOpen = !this.isDialOpen;

    if (this.isDialOpen) {
      this.addClickListener();
    } else {
      this.removeClickListener();
    }
  }

  private addClickListener() {
    // Add a slight delay so the click event doesn't immediately close the speed dial
    setTimeout(() => {
      this.documentClickListener = this.renderer.listen('document', 'click', (event: Event) => {
        const clickedInside = this.elementRef.nativeElement.contains(event.target);
        if (!clickedInside) {
          this.isDialOpen = false;
          this.removeClickListener();
        }
      });
    }, 0);
  }

  private removeClickListener() {
    if (this.documentClickListener) {
      this.documentClickListener();
      this.documentClickListener = null;
    }
  }

  ngOnDestroy() {
    this.removeClickListener();
  }
}
